let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jMdSo")).then(() => parcelRequire('9OcJb'));